import { render } from "./AddStatementModule.vue?vue&type=template&id=8c96902c&scoped=true&ts=true&lang=pug"
import script from "./AddStatementModule.vue?vue&type=script&lang=ts"
export * from "./AddStatementModule.vue?vue&type=script&lang=ts"

import "./AddStatementModule.vue?vue&type=style&index=0&id=8c96902c&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c96902c"]])

export default __exports__